import React, { useContext, useLayoutEffect } from 'react';
import axios from "axios";
import { AuthContext, } from 'contexts';
import { notification } from 'antd';
import ls from './ls';

axios.defaults.baseURL = process.env.REACT_APP_MAIN_API_URL;
const source = axios.CancelToken.source()

const masterInstance = axios.create()
masterInstance.defaults.baseURL = process.env.REACT_APP_MASTER_API_URL;

axios.interceptors.request.use(
  async (config) => {
    const loginInfo = ls.get("userInfo");
    const token = loginInfo && loginInfo.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;  
  },
  function (err) {
    return Promise.reject(err);
  }
);

const AxiosComponent = (props) => {
  const { action } = useContext(AuthContext)
  const [api, contextHolder] = notification.useNotification();
  useLayoutEffect(() => {
    axios.interceptors.response.use(
      function (response) {
        if(response.config.method === 'post'){
          if(response.config.url === 'login' ||
          response.config.url === 'tas/activetransport/getactivetransports'
          ){
            /// no message
          }
          // else if(response.config.url === 'tas/systeam/setmenu'){
          //   action.onSuccess('Changed successfully')
          // }
          else{
            action.onSuccess('Үйлдэл амжилттай')
          }
        }
        else if(response.config.method === 'put'){
          action.onSuccess('Үйлдэл амжилттай')
        }
        return response;
      },
      async (error) =>  {
        console.log('401', error);
        if(error.code === "ERR_NETWORK"){
          action.setErrorStatus(error.code)
        }
        else if(error.code === "ERR_BAD_RESPONSE"){
          action.setErrorStatus(error.code)
        }
        if(error.response) {
          if(error.response.status === 401){
            await source.cancel()
            await action.logout()
          }
          else if(error.response.code === 500){
            action.setErrorStatus(error.response.code)
          }
          else if(error.response.status === 403){
            // api.error({
            //   message: 'Access forbidden',
            //   placement: 'top',
            //   duration: 3,
            //   description: <div className='flex items-center justify-center'>
            //     <ERROR403 className='h-[200px]'/>
            //   </div>
            // });
          }
          else if(error.response.status === 400){
            // if(error.response.config.method === 'delete'){

            // }
            if(error.response.config.url === 'tas/employee/rosterexecute' && error.response.config.method === 'post'){
            }
            else if(error.response.config.method === 'post' && error.response.config.url === 'tas/sysrole/adduser'){
              api.error({
                message: 'Validation Warning',
                duration: 0,
                description: <div>
                  <ul className='list-disc'>
                    <li>{error.response.data.message}</li>
                  </ul>
                </div>
              });
            }
            else if((error.response.config.method === 'post' && error.response.config.url === 'tas/employee') ||
            (error.response.config.method === 'patch' && error.response.config.url === 'tas/employee')){
            }
            else if((error.response.config.method === 'post' && error.response.config.url === 'tas/transport/addtravel')){
              if(error.response.data?.data){
                api.error({
                  message: 'Validation Warning',
                  duration: 0,
                  description: <div>
                    <ul className='list-disc'>
                      {
                        error.response.data?.data?.map((error) => (
                          <li>{error}</li>
                        ))
                      }
                    </ul>
                  </div>
                });
              }
              else{
                if(error.response.data){
                  if(error.response.data.message) {
                    if(Array.isArray(error.response.data.value)) {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.value[0].msg
                      });
                    }
                    else {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.message
                      });
                    }
                  }
                  else{
                    api.error({
                      message: error.response.data.value,
                      duration: 5,
                      description: error.response.data.title
                    });
                  }
                }
              }
            }
            else if(error.response.config.method === 'delete' && error.response.config.url === 'tas/activetransport'){
              // action.onError(error.response.data.data[0], 5)
            }
            else{
              if(error.response.data){
                if(error.response.data.data) {
                  api.error({
                    message: 'Validation error',
                    duration: 5,
                    description: <div>
                      <ul className='list-disc'>
                        {
                          error.response.data?.data?.map((error) => (
                            <li>{error}</li>
                          ))
                        }
                      </ul>
                    </div>
                  });
                }
                else{
                  if(error.response.data.message) {
                    if(Array.isArray(error.response.data.value)) {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.value[0].msg
                      });
                    }
                    else {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.message
                      });
                    }
                  }
                  else{
                    api.error({
                      message: error.response.data.value,
                      duration: 5,
                      description: error.response.data.title
                    });
                  }
                }
              }
            }
          }
          else if(error.response.data){
            if(error.response.data.message) {
              if(Array.isArray(error.response.data.value)) {
                api.error({
                  message: error.response.data.value,
                  duration: 5,
                  description: error.response.data.value[0].msg
                });
              }
              else {
                api.error({
                  message: error.response.data.value,
                  duration: 5,
                  description: error.response.data.message
                });
              }
            }
            else{
              // if(error.response.status === 401){
              // }
              // else{
                api.error({
                  message: 'Системийн алдаа',
                  duration: 5,
                  description: error.response.data.title
                });
              // }
            }
          }
        }
        return Promise.reject(error);
      }
    );

    ////    MASTER     //////
    masterInstance.interceptors.request.use( async (config) => {
      const loginInfo = ls.get("userInfo");
      const token = loginInfo && loginInfo.token;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;  
    },(error) => {
      return Promise.reject(error)
    })

    masterInstance.interceptors.response.use(
      function (response) {
        if(response.config.method === 'post'){
          action.onSuccess('Үйлдэл амжилттай')
        }
        else if(response.config.method === 'put'){
          action.onSuccess('Үйлдэл амжилттай')
        }
        return response;
      },
      async (error) =>  {
        if(error.code === "ERR_NETWORK"){
          action.setErrorStatus(error.code)
        }
        else if(error.code === "ERR_BAD_RESPONSE"){
          action.setErrorStatus(error.code)
        }
        if(error.response) {
          if(error.response.status === 401){
            await source.cancel()
            await action.logout()
          }
          else if(error.response.code === 500){
            action.setErrorStatus(error.response.code)
          }
          else if(error.response.status === 403){
            // api.error({
            //   message: 'Access forbidden',
            //   placement: 'top',
            //   duration: 3,
            //   description: <div className='flex items-center justify-center'>
            //     <ERROR403 className='h-[200px]'/>
            //   </div>
            // });
          }
          else if(error.response.status === 400){
            if(error.response.config.url === 'tas/employee/rosterexecute' && error.response.config.method === 'post'){
            }
            else if(error.response.config.method === 'post' && error.response.config.url === 'tas/sysrole/adduser'){
              api.error({
                message: 'Validation Warning',
                duration: 0,
                description: <div>
                  <ul className='list-disc'>
                    <li>{error.response.data.message}</li>
                  </ul>
                </div>
              });
            }
            else if((error.response.config.method === 'post' && error.response.config.url === 'tas/employee') ||
            (error.response.config.method === 'patch' && error.response.config.url === 'tas/employee')){
            }
            else if((error.response.config.method === 'post' && error.response.config.url === 'tas/transport/addtravel')){
              if(error.response.data?.data){
                api.error({
                  message: 'Validation Warning',
                  duration: 0,
                  description: <div>
                    <ul className='list-disc'>
                      {
                        error.response.data?.data?.map((error) => (
                          <li>{error}</li>
                        ))
                      }
                    </ul>
                  </div>
                });
              }
              else{
                if(error.response.data){
                  if(error.response.data.message) {
                    if(Array.isArray(error.response.data.value)) {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.value[0].msg
                      });
                    }
                    else {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.message
                      });
                    }
                  }
                  else{
                    api.error({
                      message: error.response.data.value,
                      duration: 5,
                      description: error.response.data.title
                    });
                  }
                }
              }
            }
            else if(error.response.config.method === 'delete' && error.response.config.url === 'tas/activetransport'){
              // action.onError(error.response.data.data[0], 5)
            }
            else{
              if(error.response.data){
                if(error.response.data.data) {
                  api.error({
                    message: 'Validation error',
                    duration: 5,
                    description: <div>
                      <ul className='list-disc'>
                        {
                          error.response.data?.data?.map((error) => (
                            <li>{error}</li>
                          ))
                        }
                      </ul>
                    </div>
                  });
                }
                else{
                  if(error.response.data.message) {
                    if(Array.isArray(error.response.data.value)) {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.value[0].msg
                      });
                    }
                    else {
                      api.error({
                        message: error.response.data.value,
                        duration: 5,
                        description: error.response.data.message
                      });
                    }
                  }
                  else{
                    api.error({
                      message: error.response.data.value,
                      duration: 5,
                      description: error.response.data.title
                    });
                  }
                }
              }
            }
          }
          else if(error.response.data){
            if(error.response.data.message) {
              if(Array.isArray(error.response.data.value)) {
                api.error({
                  message: error.response.data.value,
                  duration: 5,
                  description: error.response.data.value[0].msg
                });
              }
              else {
                api.error({
                  message: error.response.data.value,
                  duration: 5,
                  description: error.response.data.message
                });
              }
            }
            else{
              // if(error.response.status === 401){
              // }
              // else{
                api.error({
                  message: 'Системийн алдаа',
                  duration: 5,
                  description: error.response.data.title
                });
              // }
            }
          }
        }
        return Promise.reject(error);
      }
    );
    
  }, [])
  
  return (
    <>
      {contextHolder}
      {props.children}
    </>
  )
}

export { masterInstance }
export default AxiosComponent;